const NATURE_IDENTIFICATION_OPTIONS = [
  {
    key: '00',
    text: 'Aucune',
    value: null,
  },
  {
    key: '01',
    text: '01 SIRET',
    value: '01',
  },
  {
    key: '02',
    text: '02 SIREN',
    value: '02',
  },
  {
    key: '03',
    text: '03 FINESS',
    value: '03',
  },
  {
    key: '04',
    text: '04 NIR',
    value: '04 NIR',
  },
  {
    key: '05',
    text: '05 TVA Intra Communautaire',
    value: '05',
  },
  {
    key: '06',
    text: '06 Hors UE',
    value: '06',
  },
  {
    key: '07',
    text: '07 TAHITI',
    value: '07',
  },
  {
    key: '08',
    text: '08 RIDET',
    value: '08',
  },
  {
    key: '09',
    text: '09 En Cours Immatriculation',
    value: '09',
  },
  {
    key: '10',
    text: '10 FRWF',
    value: '10',
  },
  {
    key: '12',
    text: '12 NFP',
    value: '12',
  },
];

export default NATURE_IDENTIFICATION_OPTIONS;
